module.exports = __webpack_public_path__ + "img/崔行.b02ec4e6.jpg";